import PropTypes from "prop-types";
import { Autocomplete } from "@mui/material";
import { CustomInputField } from "@/features/ui";
import { StatusEnum } from "../status-enum";
import { statusLabels } from "../status-labels";

export const PurchaseOrderStatusAutocomplete = ({
  TextFieldProps,
  ...props
}) => {
  const statusOptions = Object.values(StatusEnum).map((value) => ({
    value: value,
    label: statusLabels[value],
  }));

  return (
    <Autocomplete
      options={statusOptions}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, selectedOption) =>
        option.value === selectedOption.value
      }
      renderInput={(params) => (
        <CustomInputField
          {...TextFieldProps}
          {...params}
          InputProps={{
            ...params.slotProps.input,
            placeholder: "Pilih Status",
          }}
        />
      )}
      {...props}
    />
  );
};

PurchaseOrderStatusAutocomplete.propTypes = {
  TextFieldProps: PropTypes.object,
};
